package com.stevdza.san.sections

import androidx.compose.runtime.*
import com.stevdza.san.components.PortfolioTitle
import com.stevdza.san.components.SkillBar
import com.stevdza.san.models.Section
import com.stevdza.san.models.Skill
import com.stevdza.san.models.Theme
import com.stevdza.san.styles.AboutImageStyle
import com.stevdza.san.styles.AboutTextStyle
import com.stevdza.san.util.Constants.FONT_FAMILY
import com.stevdza.san.util.Constants.LOREM_IPSUM_SHORT
import com.stevdza.san.util.Constants.SECTION_WIDTH
import com.stevdza.san.util.ObserveViewportEntered
import com.stevdza.san.util.Res
import com.stevdza.san.util.animateNumbers
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.VerticalAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun AboutSection() {
    Box(
        modifier = Modifier
            .id(Section.About.id)
            .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = 150.px),
        contentAlignment = Alignment.Center
    ) {
        AboutContent()
    }
}

@Composable
fun AboutContent() {
    val breakpoint = rememberBreakpoint()
    Row(
        modifier = Modifier
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent
                else 90.percent
            )
            .maxWidth(1200.px),
    ) {
        AboutMe()
    }
}

@Composable
fun AboutMe() {
    val scope = rememberCoroutineScope()
    var viewportEntered by remember { mutableStateOf(false) }
    val animatedPercentage = remember { mutableStateListOf(0, 0, 0, 0, 0) }
    val breakpoint = rememberBreakpoint()
    val imageWidth = if (breakpoint >= Breakpoint.LG) 25.vw else 80.vw
    val reducedImageWidth = imageWidth.value*.75f

        Span {
        PortfolioTitle(section = Section.About)
        P(
            attrs = AboutTextStyle.toModifier()
                .margin(topBottom = 25.px, leftRight =2.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .fontStyle(FontStyle.Italic)
                .color(Theme.Secondary.rgb)
                .width(80.vw)
                .toAttrs()
        ) {
            Text("I was born in Lisbon. I studied at Academia de Música de Santa Cecília, where I was a great student, played the violin, made good friends," +
                    " and destroyed lots of kneepads playing soccer.")
            Image(
                modifier = AboutImageStyle.toModifier()
                    .width(imageWidth),
                src = Res.Image.about_1,
                alt = "About Image",
            )
            Row(modifier = Modifier.fillMaxWidth().height(5.vh)) {}
            Image(
                modifier = AboutImageStyle.toModifier()
                    .width(imageWidth),
                src = Res.Image.about_2,
                alt = "About Image",
            )
            Text("In the university I studied Physics, at IST - University of Lisbon.")
            Row(modifier = Modifier.fillMaxWidth().height(5.vh)) {}
            Text("I always looked for alternative perspectives")
            Image(
                modifier = AboutImageStyle.toModifier()
                    .width(reducedImageWidth.vw),
                src = Res.Image.about_3,
                alt = "About Image",
            )
            Row(modifier = Modifier.fillMaxWidth().height(5.vh)) {}
            Image(
                modifier = AboutImageStyle.toModifier()
                    .width(imageWidth),
                src = Res.Image.about_4,
                alt = "About Image",
            )
            Text("I currently work at VW. I work in Lisbon, but a few years ago I went to visit the main VW factory, in Wolfsburg." +
                    "I just realized that on group photos I avoid being in the middle")
            Row(modifier = Modifier.fillMaxWidth().height(5.vh)) {}
            Text("I also work on some personal projects. You can find out more ")
            Text(" ")
            Link(path = "#portfolio"){
                Text(" here")
            }
            Text(".")
            Row(modifier = Modifier.fillMaxWidth().height(5.vh)) {}
            Text("I recently finished my postgraduate course on Critical Thinking, where I got to have great lectures from great teachers, and get to know a diverse group of great colleagues.")
            Image(
                modifier = AboutImageStyle.toModifier()
                    .width(imageWidth),
                src = Res.Image.about_5,
                alt = "About Image",
            )
            Image(
                modifier = AboutImageStyle.toModifier()
                    .width(reducedImageWidth.vw),
                src = Res.Image.about_6,
                alt = "About Image",
            )
        }
    }
}
